"use client"

import { COLOR } from '@/constant/color';
import styled from 'styled-components';

export const VideoSectionContainer = styled.div`
    width: 100%;
    height: 80vh;
    margin-top: -64px;
    overflow: hidden;
    position: relative;
    user-select: none;
`

export const VideoSectionBottom = styled.div`
    position: absolute;
    width: 100%;
    height: 80px;
    left: 0;
    bottom: -6px;
    z-index: 1;
    display: flex;
    justify-content: flex-end;
`

export const VideoSectionContent = styled.div`
    position: absolute;
    width: calc(100% - 10%);
    max-width: 1280px;
    height: 200px;
    right: calc(50% - 45%);
    top: calc(50% - 100px);
    z-index: 1;
    display: flex;
    flex-direction: column;
    font-size: 52px;
    color: #ffffff;
    text-align: right;
    user-select: none;

    @media (max-width: 768px) {
        font-size: 2rem;
        word-break: break-word;
    }
`

export const VideoSectionBottomLink = styled.div`
    height: 100%;
    width: 50%;
    background: #ffffff;
    position: relative;
    display: flex;
    align-items: center;
    gap: 20px;
    padding: 0px 20px;

    & > h2 {
        word-break: keep-all;
        
        @media (max-width: 768px) {
            font-size: 1rem;
        }
    }

    & > hr {
        flex: 1;
        border: 1px solid ${COLOR.primary};
        animation: grow 1s ease-out forwards;
        transform: scaleX(0);
        transform-origin: left;

        @keyframes grow {
            to {
                transform: scaleX(1);
            }
        }
    }

    &::before {
        content: '';
        position: absolute;
        bottom: 0;
        left: -79px;
        width: 0;
        height: 0;
        border-color: transparent transparent #fff;
        border-style: solid;
        border-width: 0 0 81px 80px;
    }
`